import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import { isLoggableClickEvent } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SCROLL_THROTTLE_TIMEOUT } from '../constants';
import { BiData } from '@wix/da-bi/pkg/events';
/** Handle scroll-related events - mobile swipes and desktop arrow clicks */ export function useSliderScrollHandler(contentRef, scrollBy, onScrollBiData, enableMobileSwipeLogging) {
    const isMobile = useContext(MobileContext);
    const hasLoggedMobileSwipe = useRef(false);
    const logBiEvent = useBiLogger();
    const logMobileSwipe = isMobile && enableMobileSwipeLogging;
    const logArrowClickEvent = useCallback((contentNode, direction)=>{
        const contentWidth = contentNode.getBoundingClientRect().width;
        const scrollableArea = contentNode.scrollWidth - contentWidth;
        const perc = contentNode.scrollLeft / scrollableArea;
        logBiEvent(BiData(_object_spread_props(_object_spread({}, onScrollBiData), {
            evid: 108,
            scroll_pct: Math.round(100 * perc),
            direction
        })));
    }, [
        logBiEvent,
        onScrollBiData
    ]);
    useEffect(()=>{
        const contentNode = contentRef.current;
        if (!contentNode) {
            return;
        }
        const handleScroll = throttle(()=>{
            if (logMobileSwipe && !hasLoggedMobileSwipe.current) {
                logArrowClickEvent(contentNode);
                hasLoggedMobileSwipe.current = true;
            }
        }, SCROLL_THROTTLE_TIMEOUT, {
            leading: true
        });
        contentNode.addEventListener('scroll', handleScroll);
        return ()=>contentNode.removeEventListener('scroll', handleScroll);
    }, [
        contentRef,
        logArrowClickEvent,
        logMobileSwipe
    ]);
    const handleScrollButtonClick = useCallback((e, direction)=>{
        // capture this here so we don't need to use e.persist
        const isLoggable = isLoggableClickEvent(e.nativeEvent);
        requestAnimationFrame(()=>{
            const contentNode = contentRef.current;
            if (!contentNode || !scrollBy) {
                return;
            }
            if (isLoggable) {
                logArrowClickEvent(contentNode, direction);
            }
            const contentWidth = contentNode.getBoundingClientRect().width;
            const scrollLeft = scrollBy <= 1 ? contentWidth * scrollBy : scrollBy;
            if (direction === 'previous') {
                contentNode.scrollLeft -= scrollLeft;
            } else if (direction === 'next') {
                contentNode.scrollLeft += scrollLeft;
            }
        });
    }, [
        contentRef,
        scrollBy,
        logArrowClickEvent
    ]);
    return handleScrollButtonClick;
}
